module.exports = __webpack_public_path__ + "static/media/Pets.dce15f4f.svg";